import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { ReactElement } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export type TabsHashProps = {
  tabs: {
    key: string;
    name: string;
    content: ReactElement;
  }[];
  defaultTab: string;
};

export function TabsHash({ tabs, defaultTab }: TabsHashProps) {
  const location = useLocation();
  const history = useHistory();

  let currentHash = location.hash.replace('#', '') || defaultTab;
  if (tabs.every((tab) => tab.key !== currentHash)) {
    currentHash = defaultTab;
  }

  return (
    <Tabs
      defaultTab={currentHash}
      onSelection={(newSelected) => {
        if (newSelected !== currentHash) {
          history.replace({ ...location, hash: `#${newSelected}` });
        }
      }}
    >
      <TabsList>
        {tabs.map((tab) => (
          <Tab key={tab.key} id={tab.key} children={tab.name} />
        ))}
      </TabsList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.key} id={tab.key} children={tab.content} />
        ))}
      </TabPanels>
    </Tabs>
  );
}
